import { ActionType } from "../interfaces/api/actionType";

export const GetDesiredPlaces: ActionType = {
  FAILURE: "GET_DESIRED_PLACES_FAILURE",
  REQUEST: "GET_DESIRED_PLACES_REQUEST",
  SUCCESS: "GET_DESIRED_PLACES_SUCCESS",
};
